var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[(_vm.step == 'ResetPassword')?_c('ResetPassword',{attrs:{"userId":_vm.userId},on:{"nextStep":_vm.nextStep}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }